import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "./ReportElementHelper";

class AreaData extends Component {
  state = {
    rows: []
  };
  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = props => {
    const rows = [];
    _.forEach(_.get(props.record, "areaData"), (record, index) => {
      const recs = [];
      getAllRows(record, recs, props, _.get(record, "$.display"), 2);
      rows.push(
        <Table.Row key={`area_data_row_${index}`}>
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan={2}
                    className="report-sub-section-header"
                  >
                    Area Data
                  </Table.HeaderCell>
                </Table.Row>
                {recs}
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      );
    });
    this.setState({ rows });
  };

  render() {
    return (
      <Table key={`demo_area_tables`}>
        <Table.Body>{this.state.rows}</Table.Body>
      </Table>
    );
  }
}

export default AreaData;



// WEBPACK FOOTER //
// ./src/components/reports/AreaData.js